export interface AccountSettingsNavItem {
  label: string;
  route: string;
  danger?: boolean;
}

export const ACCOUNT_SETTINGS_NAV_ITEMS: AccountSettingsNavItem[] = [
  {
    label: 'Profile',
    route: '/account/profile'
  },
  {
    label: 'Addresses',
    route: '/account/addresses'
  },
  {
    label: 'Plans & pricing',
    route: '/billing/plans'
  },
  {
    label: 'Billing & subscription',
    route: '/account/payment-methods'
  },
  {
    label: 'Security',
    route: '/account/security'
  },
  {
    label: 'Feedback & requests',
    route: '/account/feedback'
  },
  {
    label: 'Danger zone',
    route: '/account/danger-zone',
    danger: true
  }
];
